module.exports = __webpack_public_path__ + "static/media/partyparrot.20644e95.gif";